import { useEffect } from "react";
import { useSnackbar, ProviderContext, OptionsObject, SnackbarKey } from "notistack";

// Store the snackbar context for use outside of React components
let snackbarRef: ProviderContext | undefined;

// Snackbars requested before the provider mounted (e.g. errors thrown while the
// app is still bootstrapping and only the spinner is rendered). They are held
// here and flushed as soon as the configurator mounts.
type PendingSnackbar = { message: string; options?: OptionsObject };
let pending: PendingSnackbar[] = [];

let deferredKeySeq = 0;

const flushPending = () => {
  if (!snackbarRef || !pending.length) return;
  const queued = pending;
  pending = [];
  for (const item of queued) {
    snackbarRef.enqueueSnackbar(item.message, item.options);
  }
};

export const SnackbarUtilsConfigurator: React.FC = () => {
  snackbarRef = useSnackbar();

  useEffect(() => {
    flushPending();
  }, []);

  return null;
};

export const enqueueSnackbar = (message: string, options?: OptionsObject): SnackbarKey => {
  if (!snackbarRef) {
    const key = options?.key ?? `deferred-snackbar-${++deferredKeySeq}`;
    pending.push({ message, options: { ...options, key } });
    return key;
  }
  return snackbarRef.enqueueSnackbar(message, options);
};

export const closeSnackbar = (key?: SnackbarKey): void => {
  if (!snackbarRef) {
    pending = key === undefined ? [] : pending.filter((item) => item.options?.key !== key);
    return;
  }
  snackbarRef.closeSnackbar(key);
};
